// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import EllipsisOutlinedSvg from "@ant-design/icons-svg/es/asn/EllipsisOutlined";
import AntdIcon from '../components/AntdIcon';

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlinedSvg
  }));
};

EllipsisOutlined.displayName = 'EllipsisOutlined';
export default React.forwardRef(EllipsisOutlined);